// extracted by mini-css-extract-plugin
export var hidden = "_4p-1";
export var leftPanel = "_4p-2";
export var readonlyInspector = "_4p-3";
export var rightPanel = "_4p-0";